// extracted by mini-css-extract-plugin
export default {"icon":"icon--Lyoym","close-btn":"close-btn--zAc9y","closeBtn":"close-btn--zAc9y","blink":"blink--gr6Wv"};